export interface PartidoBase {
  goles_local: number | null;
  goles_visitante: number | null;
}

export interface PrediccionBase {
  prediccion_local: number;
  prediccion_visitante: number;
}

export const getCardState = (
  p: PartidoBase,
  pred?: PrediccionBase
) => {
  if (!pred) return "no-prediccion";

  if (p.goles_local === null || p.goles_visitante === null) {
    return "esperando";
  }

  const exacto =
    pred.prediccion_local === p.goles_local &&
    pred.prediccion_visitante === p.goles_visitante;

  if (exacto) return "legendaria";

  const parcial =
    (pred.prediccion_local > pred.prediccion_visitante &&
      p.goles_local > p.goles_visitante) ||
    (pred.prediccion_local < pred.prediccion_visitante &&
      p.goles_local < p.goles_visitante) ||
    (pred.prediccion_local === pred.prediccion_visitante &&
      p.goles_local === p.goles_visitante);

  if (parcial) return "acierto-parcial";

  return "fallo";
};
